type IconProps = {
  className?: string;
};

export const NewActionIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1294 1.70327C12.3519 1.78796 12.4994 2.00527 12.4994 2.24817V8.64363H16.0983C16.3206 8.64363 16.5225 8.77627 16.615 8.98309C16.7075 9.18991 16.6736 9.43294 16.5283 9.60503L9.3317 18.132C9.17656 18.3159 8.92612 18.3816 8.70361 18.2969C8.48114 18.2122 8.33357 17.9949 8.33357 17.752V11.3566H4.73466C4.5124 11.3566 4.31054 11.2239 4.21805 11.0171C4.12555 10.8103 4.1594 10.5673 4.30468 10.3951L11.5013 1.86816C11.6564 1.68432 11.9069 1.61857 12.1294 1.70327Z"
      fill="currentColor"
    />
  </svg>
);
